import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import { formatDate } from "@backpacker/date";
import { localize } from "@backpacker/number";
import { Dot } from "@charty/legend/item";
import Tooltip from "@charty/tooltip";
import { Spacing } from "@glossy";
import { AbstractDate } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { Timezone } from "@linkfluence/models/timezone";
import { tz } from "@tootools/date";

type Serie = {
  count: number;
  label: string;
  color: string;
  date: AbstractDate;
};
interface IProps {
  dataSeries: Serie[];
  locale: Locale;
  timezone: Timezone;
  metricLabel?: string;
  withPreviousPeriod?: boolean;
}

const Line = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${Spacing.ExtraSmall};
`;

export const getLabels = (
  date,
  locale,
  timezone,
  metricLabel = null,
  withPreviousPeriod = false
) => {
  const formatedDate = formatDate(tz(date, timezone), locale, "ll");
  const title = metricLabel ? [formatedDate, metricLabel] : [formatedDate];
  return withPreviousPeriod ? [metricLabel] : title;
};

export const getContentValues = (
  dataSeries,
  locale,
  timezone,
  withPreviousPeriod = false
) =>
  map(dataSeries, (serie) => {
    const { date, count, label } = serie;
    if (withPreviousPeriod) {
      return (
        " " +
        formatDate(tz(date, timezone), locale, "ll") +
        ": " +
        localize(locale, count)
      );
    }
    return " " + label + ": " + localize(locale, count);
  });

const RadarlyWidgetTooltipLineChart = ({
  dataSeries,
  metricLabel,
  withPreviousPeriod,
  locale,
  timezone,
}: IProps) => {
  return (
    <Tooltip
      label={map(
        getLabels(
          dataSeries[0].date,
          locale,
          timezone,
          metricLabel,
          withPreviousPeriod
        ),
        (label, index) => (
          <div key={index}>{label}</div>
        )
      )}
      content={map(
        getContentValues(dataSeries, locale, timezone, withPreviousPeriod),
        (content, index) => (
          <Line key={index}>
            <Dot color={dataSeries[index].color} />
            <span>{content}</span>
          </Line>
        )
      )}
    />
  );
};

export default RadarlyWidgetTooltipLineChart;
